import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TestBookingNotification = (props) => {
    const { data, translate } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    // When the booking is not a test order, this notification isn't applicable.
    if (!data.is_test_order) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate('resources.orders.information.test_booking') }
        </ErrorMessageField>
    );
};

TestBookingNotification.propTypes = {
    data: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(TestBookingNotification);



// WEBPACK FOOTER //
// ./src/components/notifications/TestBookingNotification.js